"use strict";

exports.__esModule = true;
exports.DeviceTagFilter = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DropdownCheckboxList = require("../../Core/DropdownCheckboxList");
var _DeviceTagListContext = require("../../Device/DeviceTagListContext");
var _URLFilter = require("../../Core/URLFilter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceTagFilter = exports.DeviceTagFilter = function DeviceTagFilter() {
  var deviceTags = _react["default"].useContext(_DeviceTagListContext.DeviceTagListContext);
  var _React$useContext = _react["default"].useContext(_URLFilter.URLFilterContext),
    filters = _React$useContext.filters,
    setFilter = _React$useContext.setFilter;
  return /*#__PURE__*/_react["default"].createElement(_DropdownCheckboxList.DropdownCheckboxList, {
    minimal: true,
    style: {
      maxWidth: 250,
      marginRight: "1rem"
    },
    items: deviceTags,
    selected: filters.tags,
    multiple: true,
    toggle: true,
    onSelect: function onSelect(tags) {
      return setFilter("tags", tags);
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.toLowerCase().includes(query.toLowerCase());
    },
    renderItemText: function renderItemText(item) {
      return item;
    },
    getKey: function getKey(item) {
      return item;
    },
    placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportToolbar.deviceTags.placeholder",
      defaultMessage: "Tags"
    })
  });
};